import request from '@/utils/request'

export const platformCommunityInsert = (data = {}) => request({ url: `/api/uc/v1/platform/platformCommunityInsert`, method: 'post', data })

export const platformConveniencePhoneUpdate = (data = {}) => request({ url: `/api/uc/v1/platform/platformConveniencePhoneUpdate`, method: 'post', data })

export const platformCommunityUpdate = (data = {}) => request({ url: `/api/uc/v1/platform/platformCommunityUpdate`, method: 'post', data })

export const introductionVideoPage = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoPage`, method: 'post', data })

export const introductionVideoCount = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoCount`, method: 'post', data })

export const introductionVideoDel = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoDel`, method: 'post', data })

export const introductionVideoDelBatch = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoDelBatch`, method: 'post', data })

export const introductionVideoIns = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoIns`, method: 'post', data })

export const introductionVideoUpd = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoUpd`, method: 'post', data })

export const communityAuditPage = (data = {}) => request({ url: `/api/uc/v1/platform/communityAuditPage`, method: 'post', data })

export const organizationDetail = (data = {}) => request({ url: `/api/uc/v1/organization/organizationDetail`, method: 'post', data })

export const getTenantById = (data = {}) => request({ url: `/api/uc/v1/tenant/getTenantById`, method: 'post', data })

// 令牌管理
export const dynamicTokenList = (data = {}) => request({ url: `/api/uc/v1/hardware/dynamicTokenList`, method: 'post', data })

export const dynamicTokenCount = (data = {}) => request({ url: `/api/uc/v1/hardware/dynamicTokenCount`, method: 'post', data })

export const dynamicTokenIns = (data = {}) => request({ url: `/api/uc/v1/hardware/dynamicTokenIns`, method: 'post', data })

export const dynamicTokenDel = (data = {}) => request({ url: `/api/uc/v1/hardware/dynamicTokenDel`, method: 'post', data })

//租户-订单管理
export const platformMerchantOrderPage = (data = {}) => request({ url: `/api/shop/v1/trade/platformMerchantOrderPage`, method: 'post', data })

export const platformMerchantOrderCount = (data = {}) => request({ url: `/api/shop/v1/trade/platformMerchantOrderCount`, method: 'post', data })

export const organOrderPage = (data = {}) => request({ url: `/api/shop/v1/trade/organOrderPage`, method: 'post', data })

export const organOrderCount = (data = {}) => request({ url: `/api/shop/v1/trade/organOrderCount`, method: 'post', data })

export const platformMerchantOrderAdd = (data = {}) => request({ url: `/api/shop/v1/trade/platformMerchantOrderAdd`, method: 'post', data })

//租户-版本管理
export const appInfoPage = (data = {}) => request({ url: `/api/uc/v1/appversion/appInfoPage`, method: 'post', data })

export const appVersionCount = (data = {}) => request({ url: `/api/uc/v1/appversion/appVersionCount`, method: 'post', data })

export const appInfoUpd = (data = {}) => request({ url: `/api/uc/v1/appversion/appInfoUpd`, method: 'post', data })

export const getAppHistoryPage = (data = {}) => request({ url: `/api/uc/v1/appversion/getAppHistoryPage`, method: 'post', data })

export const appVersionRecordCount = (data = {}) => request({ url: `/api/uc/v1/appversion/appVersionRecordCount`, method: 'post', data })

// 短信签名
export const platformSmsSignatureRecordPage = (data = {}) => request({ url: `/api/estate/v1/charge/platformSmsSignatureRecordPage`, method: 'post', data })

export const platformSmsSignatureRecordCount = (data = {}) => request({ url: `/api/estate/v1/charge/platformSmsSignatureRecordCount`, method: 'post', data })

// 协议管理
export const agreementManagePage = (data = {}) => request({ url: `/api/uc/v1/platform/agreementManagePage`, method: 'post', data })

export const agreementManageCount = (data = {}) => request({ url: `/api/uc/v1/platform/agreementManageCount`, method: 'post', data })

export const agreementManageDetail = (data = {}) => request({ url: `/api/uc/v1/platform/agreementManageDetail`, method: 'post', data })

export const agreementManageIns = (data = {}) => request({ url: `/api/uc/v1/platform/agreementManageIns`, method: 'post', data })

export const agreementManageUpd = (data = {}) => request({ url: `/api/uc/v1/platform/agreementManageUpd`, method: 'post', data })

export const agreementManageDel = (data = {}) => request({ url: `/api/uc/v1/platform/agreementManageDel`, method: 'post', data })

// 版本管理
export const updAuditStatus = (data = {}) => request({ url: `/api/uc/v1/appversion/updAuditStatus`, method: 'post', data })

// 视频专题
export const introductionVideoMenuPage = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoMenuPage`, method: 'post', data })

export const introductionVideoMenuCount = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoMenuCount`, method: 'post', data })

export const introductionVideoMenuIns = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoMenuIns`, method: 'post', data })

export const introductionVideoMenuUpd = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoMenuUpd`, method: 'post', data })

export const introductionVideoMenuDel = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoMenuDel`, method: 'post', data })

export const introductionVideoCountAdd = (data = {}) => request({ url: `/api/uc/v1/platform/introductionVideoCountAdd`, method: 'post', data })
